import api from '@/api'
import { sortBy } from 'lodash'

export default {
  namespaced: true,

  state: () => ({
    data: []
  }),

  actions: {
    get: async function (ctx, params) {
      const response = await api.get(`/v1/products`, params)

      ctx.commit('set', response.data)
    }
  },

  mutations: {
    set: function (state, products) {
      const data = products.map(product => ({ name: product.name, _id: product._id }))
      state.data = sortBy(data, 'name')
    },
    reset: function (state) {
      state.data = []
    }
  }
}
